// extracted by mini-css-extract-plugin
module.exports = {"null_result":"null_result--NoResources-Resources-routes__2sJOd","nullResult":"null_result--NoResources-Resources-routes__2sJOd"};